// Turns the designer's HTML into email-safe HTML: inline styles on every element, buttons as tables.
const ST = {
  p: "margin:0 0 12px 0;", h1: "margin:0 0 14px 0;font-size:28px;line-height:1.2;", h2: "margin:0 0 12px 0;font-size:22px;line-height:1.25;",
  h3: "margin:0 0 10px 0;font-size:18px;", ul: "margin:0 0 12px 0;padding-left:22px;", ol: "margin:0 0 12px 0;padding-left:22px;", li: "margin:0 0 4px 0;",
  img: "max-width:100%;height:auto;border:0;display:block;margin:0 auto 12px auto;", hr: "border:0;border-top:1px solid #dddddd;margin:18px 0;",
  table: "border-collapse:collapse;width:100%;margin:0 0 12px 0;", td: "border:1px solid #dddddd;padding:8px;vertical-align:top;", th: "border:1px solid #dddddd;padding:8px;background:#f3f3f3;text-align:left;",
  a: "color:#0b63c5;text-decoration:underline;", blockquote: "margin:0 0 12px 0;padding:8px 14px;border-left:4px solid #dddddd;color:#555555;",
};

export function toEmailHtml(html) {
  const doc = new DOMParser().parseFromString(`<div id="r">${html || ""}</div>`, "text/html");
  const root = doc.getElementById("r");
  root.querySelectorAll("*").forEach((el) => {
    const t = el.tagName.toLowerCase();
    if (ST[t]) el.setAttribute("style", `${ST[t]}${el.getAttribute("style") || ""}`);
    if (t === "p" && el.style.textAlign) el.setAttribute("align", el.style.textAlign);
    if (t === "img" && !el.getAttribute("alt")) el.setAttribute("alt", "");
    if (t === "a") el.setAttribute("target", "_blank");
  });
  // buttons: <a data-btn> -> bulletproof table button
  root.querySelectorAll("a[data-btn]").forEach((a) => {
    const bg = a.getAttribute("data-btn") || "#0b4f8a";
    const tbl = doc.createElement("table");
    tbl.setAttribute("role", "presentation"); tbl.setAttribute("align", "center"); tbl.setAttribute("cellpadding", "0"); tbl.setAttribute("cellspacing", "0");
    tbl.setAttribute("style", "margin:8px auto 16px auto;");
    tbl.innerHTML = `<tr><td style="background:${bg};border-radius:6px;padding:12px 26px"><a href="${a.getAttribute("href")}" target="_blank" style="color:#ffffff;font-weight:bold;font-size:16px;text-decoration:none;font-family:Arial,sans-serif">${a.textContent}</a></td></tr>`;
    const p = a.closest("p");
    (p && p.textContent.trim() === a.textContent.trim() ? p : a).replaceWith(tbl);
  });
  return root.innerHTML;
}

export const smsSegments = (t) => {
  const len = (t || "").length + 22; // + "\nReply STOP to opt out"
  return len <= 160 ? 1 : Math.ceil(len / 153);
};
